// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a2502ffe","396":"0a7efa48","455":"674d5340","977":"6b5ea055"}[chunkId] + ".chunk.js";
};